<template>
  <div id="app">
    <AuthGuard>
      <RouterView />
    </AuthGuard>
  </div>
</template>

<script>
import AuthGuard from './components/AuthGuard.vue'

export default {
  name: 'App',
  components: {
    AuthGuard
  },
  mounted() {
    // Enviar la altura inmediatamente tras el primer tick
    this.$nextTick(() => {
      this.sendHeight();
    });
    // Enviar de nuevo la altura después de 1 segundo por si el contenido tarda en cargar
    setTimeout(() => {
      this.sendHeight();
    }, 1000);
    // Escuchar cambios de tamaño
    window.addEventListener('resize', this.sendHeight);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.sendHeight);
  },
  methods: {
    sendHeight() {
      // Calcula la altura usando el máximo entre body y documentElement
      const height = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight
      );
      console.log('Enviando altura:', height);
      window.parent.postMessage({ iframeHeight: height }, "*");
    }
  }
};
</script>
